import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";

/**
 * Barra de pills para selecionar a lista de contatos ativa (segmento),
 * criar novas listas rapidamente e excluir listas (via `onDeleteList` —
 * o pill precisa ser um <div> porque botão dentro de botão é HTML
 * inválido).
 */
export default function ListSelectorBar({ lists, activeListId, onSelect, onCreateList, onDeleteList }) {
  const [creating, setCreating] = useState(false);
  const [newListName, setNewListName] = useState("");

  const handleCreate = () => {
    const name = newListName.trim();
    if (!name) {
      setCreating(false);
      return;
    }
    onCreateList(name);
    setNewListName("");
    setCreating(false);
  };

  return (
    <div className="list-selector">
      <button
        className={`list-pill ${!activeListId ? "active" : ""}`}
        onClick={() => onSelect(null)}
      >
        Todos os contatos
      </button>

      {lists.map((list) => (
        <div
          key={list.id}
          role="button"
          tabIndex={0}
          className={`list-pill ${activeListId === list.id ? "active" : ""}`}
          onClick={() => onSelect(list.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onSelect(list.id);
          }}
        >
          {list.name}
          {onDeleteList && (
            <button
              type="button"
              className="list-pill-delete"
              title={`Excluir lista "${list.name}"`}
              onClick={(e) => {
                e.stopPropagation();
                onDeleteList(list);
              }}
            >
              <FiX />
            </button>
          )}
        </div>
      ))}

      {creating ? (
        <input
          autoFocus
          type="text"
          placeholder="Nome da lista..."
          value={newListName}
          onChange={(e) => setNewListName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleCreate();
            if (e.key === "Escape") setCreating(false);
          }}
          onBlur={handleCreate}
          style={{
            padding: "7px 14px",
            borderRadius: 999,
            border: "1px solid rgba(16,185,129,0.4)",
            background: "transparent",
            outline: "none",
            fontSize: "0.78em",
            minWidth: 140,
          }}
        />
      ) : (
        <button className="list-pill-new" onClick={() => setCreating(true)}>
          <FiPlus /> Nova Lista
        </button>
      )}
    </div>
  );
}
